import React, { useState, useRef, useEffect } from 'react';
import './index.m.less';
const defaultMinHeight = 35;

const TextArea = props => {
  const { maxLength, value, wordsum, defaultValue, hwClass, minHeight } = props;
  const [inputValue, setInputValue] = useState(defaultValue || value);
  const inputRef = useRef();
  const textMinHeight = minHeight || defaultMinHeight;

  useEffect(() => {
    setInputValue(defaultValue);
  }, [defaultValue]);
  useEffect(() => {
    setHeight(inputRef.current);
  }, [inputValue]);

  const setHeight = target => {
    if (target?.style) {
      target.style.height = `${textMinHeight}px`;
      target.style.height = Math.max(target.scrollHeight, textMinHeight) + 'px';
    }
  };
  const onChange = evt => {
    setHeight(evt?.target);
    props.onChange && props.onChange(evt);
    setInputValue(evt?.target.value);
  };

  return (
    <div class={`text_area_div ${hwClass}`}>
      <input ref={inputRef} style={{ paddingBottom: wordsum ? '10px' : '' }} className={'hw_text_area'} {...props} onChange={onChange}></input>
      {maxLength && (
        <div class={'count'}>
          <span>{inputValue ? inputValue.length : '0'}/</span>
          {wordsum || maxLength}
        </div>
      )}
    </div>
  );
};

export default TextArea;
